//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { required, integer } from "vuelidate/lib/validators";
import setUsers from "@/components/Diagrams/config/set-users.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQDropdownBadge from "@/components/Generics/AQDropdownBadge/AQDropdownBadge.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";

export default {
    components: {
        notificationsPreview:
        () => import(/* webpackChunkName: "notificationsPreview" */ "@/components/Diagrams/config/subcomponents/notifications-preview.vue"),
        setNotifications: () => import(/* webpackChunkName: "setNotifications" */ "@/components/Diagrams/config/set-notifications.vue"),
        setDeadline: () => import(/* webpackChunkName: "setDeadline" */ "@/components/Diagrams/config/set-deadline.vue"),
        setTaskPriority: () => import(/* webpackChunkName: "setTaskPriority" */ "@/components/Diagrams/config/set-task-priority.vue"),
        setTaskSubject: () => import(/* webpackChunkName: "setTaskSubject" */ "@/components/Diagrams/config/set-task-subject.vue"),
        setInstanceName: () => import(/* webpackChunkName: "setInstanceName" */ "@/components/Diagrams/config/set-instance-name.vue"),
        setContinueIfRejected: () => import(/* webpackChunkName: "setContinueIfRejected" */ "@/components/Diagrams/config/set-continue-if-rejected.vue"),
        setApprovalTime: () => import(/* webpackChunkName: "setApprovalTime" */ "@/components/Diagrams/config/set-approval-time.vue"),
        setUsers,
        AQDropdown,
        AQDropdownBadge,
        AQButton,
        AQCard,
        AQInput,
        AQChip,
        AQListBtn,
        QAuModelPicker,
        AQTooltip
    },
    props: {
        value: {
            required: true,
            type: Object
        },
        hideOutcomes: {
            type: Object
        },
        elementIndex: {
            type: Number
        },
        hideInitialValues: {
            type: Object
        },
        readonly: {
            type: Boolean
        },
        approvalFields: {
            type: Boolean
        },
        currentLevelDetails: {
            type: Object
        },
        fromLevel: {
            type: Boolean
        },
        fromConnector: Boolean
    },
    data() {
        return {
            outcomes: [],
            selectedNotification: null,
            showSetNotifications: false,
            selectedTab: "tabUsers",
            separateTask: false,
            approversNumber: null,
            deleteCardIndex: null,
            approvalsInputError: false,
            hasError: false,
            listKey: 0,
            badgeList: [
                {
                    value: "txt",
                    button: "txt"
                },
                {
                    value: "mod",
                    button: "mod"
                }
            ],
            roleDdlOptions: [
                {
                    value: "appr",
                    label: this.$t("diagrams.components.ruleOutcomes.approveBtn"),
                    tooltipProps: {
                        tooltipContent: this.$t("diagrams.components.ruleOutcomes.approverTooltip")
                    }
                },
                {
                    value: "eval",
                    label: this.$t("diagrams.components.ruleOutcomes.evaluateBtn"),
                    tooltipProps: {
                        tooltipContent: this.$t("diagrams.components.ruleOutcomes.evaluatorTooltip")
                    }
                },
                {
                    value: "ovr",
                    label: this.$t("diagrams.components.ruleOutcomes.overrideBtn"),
                    tooltipProps: {
                        tooltipContent: this.$t("diagrams.components.ruleOutcomes.overriderTooltip")
                    }
                }
            ],
            decisionTypeDdlOptions: [
                {
                    value: "singular",
                    label: this.$t("diagrams.components.ruleOutcomes.singular"),
                    tooltipProps: {
                        tooltipContent: this.$t("diagrams.components.ruleOutcomes.singularTooltip")
                    }
                },
                {
                    value: "group",
                    label: this.$t("diagrams.components.ruleOutcomes.group"),
                    tooltipProps: {
                        tooltipContent: this.$t("diagrams.components.ruleOutcomes.groupTooltip")
                    }
                }
            ],
            firstTimeValue: true,
            hideListBtns: ["edit", "more", "copy", "download"]
        };
    },
    validations: {
        approversNumber: {
            required,
            integer
        }
    },
    computed: {
        ...mapGetters("diagrams", [
            "selectedPluginConfigData",
            "componentsConfig",
            "getParallelHTCheckbox"
        ]),
        currentIfExpiresValue() {
            // for approval matrix
            if (this.currentLevelDetails) {
                return typeof this.currentLevelDetails.settings.ifExpires !== "undefined" ? this.currentLevelDetails.settings.ifExpires : false;
            }
            return typeof this.selectedPluginConfigData[this.componentsConfig.expiration.propName]
            !== "undefined" ? this.selectedPluginConfigData[this.componentsConfig.expiration.propName] : "AR";
        },
        currentContinueIfRejectedValue() {
            return this.currentLevelDetails && typeof this.currentLevelDetails.settings.continueIfRejected
            !== "undefined" ? this.currentLevelDetails.settings.continueIfRejected : false;
        },
        currentApprovalTime() {
            // for approval matrix
            let approvalTimeValue = { approvalTime: null, timeUnit: null };

            if (this.currentLevelDetails && typeof this.currentLevelDetails.settings.approvalTime !== "undefined") {
                approvalTimeValue = this.currentLevelDetails.settings.approvalTime;
            }
            return approvalTimeValue;
        },
        dataModelConstraints() {
            return { types: ["integer", "string"] };
        }
    },
    watch: {
        value: {
            handler(v) {
                const defaults = {
                    targets: v && v.targets ? v.targets : [],
                    notifications: v && v.notifications ? v.notifications : [],
                    deadline: v.deadline || this.selectedPluginConfigData[this.componentsConfig.deadline.propName],
                    taskPriority: v.taskPriority || this.selectedPluginConfigData[this.componentsConfig.taskPriority.propName] || "lowest",
                    taskSubject: v.taskSubject || this.selectedPluginConfigData[this.componentsConfig.taskSubject.propName],
                    instanceName: v.instanceName || this.selectedPluginConfigData[this.componentsConfig.instanceName.propName],
                    continueIfRejected: this.getContinueIfRejected(v),
                    ifExpires: v.ifExpires || this.currentIfExpiresValue,
                    approvalTime: v.approvalTime || this.currentApprovalTime
                };
                if (v) {
                    Object.keys(v).forEach(key => {
                        if (!defaults.hasOwnProperty(key)) {
                            defaults[key] = v[key];
                        }
                    });
                }

                if (this.firstTimeValue) {
                    this.outcomes = defaults;
                    this.firstTimeValue = false;
                }
            },
            immediate: true
        },
        outcomes: {
            handler(v) {
                this.$emit("input", v);
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        if (!this.outcomes.targets.length) {
            this.addNewUserLine();
        }
        this.selectedTab = this.fromConnector ? "tabNotifications" : "tabUsers";
        this.separateTask = this.getParallelHTCheckbox && this.selectedPluginConfigData.pluginType === "TASK_PLUGIN";
    },
    methods: {
        getContinueIfRejected(data) {
            const { continueIfRejected } = data;
            return typeof continueIfRejected === "boolean" ? continueIfRejected : this.currentContinueIfRejectedValue;
        },
        setTargetRight(value, target) {
            target.right = value[0].value;
            if (target.right !== "appr") {
                target.approvalThreshold = null;
            }
            this.emitError();
        },
        onAddNewNotification() {
            this.selectedNotification = null;
            this.showSetNotifications = true;
        },
        saveNotification(notification) {
            let found = false;

            for (let i = 0; i < this.outcomes.notifications.length; i++) {
                const el = this.outcomes.notifications[i];

                if (el.id === notification.id) {
                    found = true;
                    this.$set(this.outcomes.notifications, i, notification);

                    break;
                }
            }

            if (!found) {
                this.outcomes.notifications.push(notification);
            }

            this.showSetNotifications = false;
            this.$emit("outcomesChanged");
        },
        selectedBehaviour(selectedType) {
            this.outcomes.ifExpires = selectedType;
        },
        workScheduleInfo(data) {
            this.outcomes.useWorkingSchedule = data;
        },
        deleteNotification(id) {
            const indexId = this.outcomes.notifications.findIndex(element => element.id === id);
            if (indexId > -1) {
                this.outcomes.notifications.splice(indexId, 1);
                this.$emit("outcomesChanged");
            }
        },
        addNewUserLine() {
            this.outcomes.targets.push({
                to: {},
                task: 1,
                prolonger: false,
                right: "appr",
                approvalThreshold: null,
                hasError: false,
                badgeType: { value: "txt", button: "txt" }
            });
        },
        deleteCard(index) {
            this.outcomes.targets.splice(index, 1);
            ++this.listKey;
        },
        approvalsInputErrorMsg(approvals, type) {
            let msg = "";
            if (!approvals || Number(approvals) === 0) {
                msg = type && type.value === "txt"
                    ? this.$t("diagrams.components.ruleOutcomes.noApprovalsError") : this.$t("diagrams.components.ruleOutcomes.noApprovalsDMError");
            } else {
                msg = this.$t("diagrams.components.ruleOutcomes.integerError");
            }
            return msg;
        },
        changedDecisionType(event, target, i) {
            if (event[0].value === "singular") {
                target.approvalThreshold = null;
            } else if (!target.approvalThreshold) {
                if (target.badgeType && target.badgeType.value === "mod") {
                    target.hasError = false;
                    setTimeout(() => { this.$refs[`menuParent${i}`][0].click(); }, 0);
                    target.approvalThreshold = "";
                } else {
                    target.approvalThreshold = 1;
                }
            }
            this.emitError();
        },
        cardOpen(event, target) {
            target.isOpen = event;
        },
        getRole(value) {
            let retVal = "";
            for (let i = 0; i < this.roleDdlOptions.length; i++) {
                if (value === this.roleDdlOptions[i].value) {
                    retVal = this.roleDdlOptions[i].label;
                    break;
                }
            }
            return retVal;
        },
        approvalsError(item) {
            return (item.badgeType && item.badgeType.value === "txt"
                && (!Number(item.approvalThreshold) || !Number.isInteger(Number(item.approvalThreshold)) || Number(item.approvalThreshold) < 0))
            || (item.badgeType && item.badgeType.value === "mod" && !item.approvalThreshold && item.hasError);
        },
        emitError() {
            const atLeastOneError = this.outcomes.targets.some(
                target => target.right === "appr" && target.decisionTypeDdl && target.decisionTypeDdl[0].value === "group"
                    && (this.approvalsError(target) || !target.approvalThreshold)
            );
            this.$emit("onApprovalsError", atLeastOneError);
        },
        groupNumber(target, i) {
            target.task = i + 1;
            return target.task;
        },
        badgeSelected(item, target, i) {
            target.hasError = false;
            if (item && item.value === "mod") {
                setTimeout(() => { this.$refs[`menuParent${i}`][0].click(); }, 0);
                target.approvalsReadonly = true;
                target.approvalThreshold = "";
            } else {
                target.approvalsReadonly = false;
                target.approvalThreshold = 1;
            }
            this.emitError();
        },
        onModelSelect(modelSelected, target) {
            target.approvalThreshold = modelSelected.model;
            [target.chipClass, target.chipAttr] = modelSelected.model.replace("m_", "").split(".");
            for (let i = 0; i < this.$refs.popoverRef.length; i++) {
                this.$refs.popoverRef[i].hide();
            }
            this.emitError();
        },
        selectedBadge(target) {
            let retVal;
            if (target.badgeType) {
                retVal = target.badgeType;
            } else if (!Number(target.approvalThreshold)) {
                retVal = { value: "mod", button: "mod" };
                target.badgeType = retVal;
                [target.chipClass, target.chipAttr] = target.approvalThreshold.replace("m_", "").split(".");
            }
            return retVal;
        }
    }
};
